export default __webpack_public_path__ + "static/media/HMB.3399e778.png";